import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import api from '../../utils/api';

const Questions = () => {
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({
    totalPapers: 0,
    totalQuestions: 0,
    totalStaff: 0,
    totalStudents: 0
  });

  useEffect(() => {
    fetchDashboardData()
  }, []);

  async function fetchDashboardData() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "getDashboardDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", programType);

      const response = await api.post("dashboard/dashboardCurl", fd);
      console.log("Dashboard Response:", response);

      if (response.data.status === "success") {
        setDashboardData({
          totalPapers: response.data.totalPapers,
          totalQuestions: response.data.totalQuestions,
          totalStaff: response.data.totalStaff,
          totalStudents: response.data.totalStudents,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  }

  return (
    <div className="questions-container">
      {/* Dashboard Stats Row */}
      <div className="dashboard-stats-row">
        <div className="stats-item">
          <div className="stats-icon">
            <i className="ph-duotone ph-file-text"></i>
          </div>
          <div className="stats-details">
            <span className="stats-label">Total Questions</span>
            <span className="stats-value">{dashboardData.totalQuestions}</span>
          </div>
        </div>

        <div className="stats-item">
          <div className="stats-icon">
            <i className="ph-duotone ph-users"></i>
          </div>
          <div className="stats-details">
            <span className="stats-label">Total Students</span>
            <span className="stats-value">{dashboardData.totalStudents}</span>
          </div>
        </div>

        <div className="stats-item">
          <div className="stats-icon">
            <i className="ph-duotone ph-user-gear"></i>
          </div>
          <div className="stats-details">
            <span className="stats-label">Total Staff</span>
            <span className="stats-value">{dashboardData.totalStaff}</span>
          </div>
        </div>

        <div className="stats-item">
          <div className="stats-icon">
            <i className="ph-duotone ph-archive"></i>
          </div>
          <div className="stats-details">
            <span className="stats-label">Total Papers</span>
            <span className="stats-value">{dashboardData.totalPapers}</span>
          </div>
        </div>
      </div>

  

      <div className="questions-grid">
        {/* Verified Questions Card */}
        <div className="questions-card" onClick={() => navigate("/question-details")}>
          <div className="card-icon-wrapper bg-emerald-100">
            <i className="ph-duotone ph-seal-check"></i>
          </div>
          <h3>Verified Questions</h3>
          <p>View all verified questions</p>
          <span className="card-action">View →</span>
        </div>

        {/* Unverified Questions Card */}
        <div className="questions-card" onClick={() => navigate("/question-details-verify")}>
          <div className="card-icon-wrapper bg-blue-100">
            <i className="ph-duotone ph-x-circle"></i>
          </div>
          <h3>Unverified Questions</h3>
          <p>Questions pending verification</p>
          <span className="card-action">Verify →</span>
        </div>

        {/* Add Questions Card */}
        <div className="questions-card" onClick={() => navigate("/add-question")}>
          <div className="card-icon-wrapper bg-cyan-100">
            <i className="ph-duotone ph-file-plus"></i>
          </div>
          <h3>Add Questions</h3>
          <p>Create new questions manually</p>
          <span className="card-action">Create →</span>
        </div>

        {/* Import Questions Card */}
        <div className="questions-card" onClick={() => navigate("/import-question")}>
          <div className="card-icon-wrapper bg-indigo-100">
            <i className="ph-duotone ph-download-simple"></i>
          </div>
          <h3>Import Questions</h3>
          <p>Bulk import questions from files</p>
          <span className="card-action">Import →</span>
        </div>

        {/* Convert Questions Card */}
        <div className="questions-card" onClick={() => navigate("/pdf-latex")}>
          <div className="card-icon-wrapper bg-rose-100">
            <i className="ph-duotone ph-atom"></i>
          </div>
          <h3>Convert Questions</h3>
          <p>Convert PDF/Latex to questions</p>
          <span className="card-action">Convert →</span>
        </div>

        {/* Practice Questions Card */}
        <div className="questions-card" onClick={() => navigate("/practice-questions")}>
          <div className="card-icon-wrapper bg-amber-100">
            <i className="ph-duotone ph-pencil"></i>
          </div>
          <h3>Practice Questions</h3>
          <p>Access practice question sets</p>
          <span className="card-action">Practice →</span>
        </div>
      </div>

      <style>
        {`
          .questions-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }
          
          /* Dashboard Stats Row Styles */
          .dashboard-stats-row {
          
            margin: 0 auto 2.5rem;
            padding: 0 0.75rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: white;
            border-radius: 1rem;
            padding: 1.25rem 1.5rem;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            border: 1px solid #e2e8f0;
            gap: 1.5rem;
          }
          
          .stats-item {
            display: flex;
            align-items: center;
            flex: 1;
            min-width: 0;
            padding: 0.5rem 0;
            position: relative;
          }
          
          .stats-item:not(:last-child)::after {
            content: '';
            position: absolute;
            right: -0.75rem;
            top: 50%;
            transform: translateY(-50%);
            height: 40px;
            width: 1px;
            background: linear-gradient(to bottom, transparent, #e2e8f0, transparent);
          }
          
          .stats-icon {
            width: 44px;
            height: 44px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 1rem;
            flex-shrink: 0;
          }
          
          /* Icon colors matching your design */
          .stats-item:nth-child(1) .stats-icon {
            background-color: #dbeafe;
            color: #2563eb;
          }
          
          .stats-item:nth-child(2) .stats-icon {
            background-color: #d1fae5;
            color: #059669;
          }
          
          .stats-item:nth-child(3) .stats-icon {
            background-color: #fef3c7;
            color: #d97706;
          }
          
          .stats-item:nth-child(4) .stats-icon {
            background-color: #f3e8ff;
            color: #7c3aed;
          }
          
          .stats-icon i {
            font-size: 1.25rem;
          }
          
          .stats-details {
            flex: 1;
            min-width: 0;
          }
          
          .stats-label {
            display: block;
            font-size: 0.8125rem;
            font-weight: 500;
            color: #4a5568;
            margin-bottom: 0.25rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          
          .stats-value {
            display: block;
            font-size: 1.5rem;
            font-weight: 700;
            color: #2d3748;
            line-height: 1;
          }
          
          .questions-header {
         
            margin: 0 auto 2.5rem;
            padding: 0 0.75rem;
          }
          
          .questions-header h1 {
            font-size: 2rem;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 0.5rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          .questions-header p {
            font-size: 1rem;
            color: #718096;
          }
          
          .questions-grid {
          
            margin: 0 auto;
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            gap: 1.25rem;
            padding: 0 0.75rem;
          }
          
          .questions-card {
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            border: 1px solid #e2e8f0;
            position: relative;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
            min-height: 180px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          }
          
          .questions-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            background: linear-gradient(90deg, #667eea, #764ba2);
            opacity: 0;
            transition: opacity 0.3s;
          }
          
          .questions-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
            border-color: #cbd5e0;
          }
          
          .questions-card:hover::before {
            opacity: 1;
          }
          
          .questions-card:hover .card-action {
            opacity: 1;
            transform: translateX(0);
          }
          
          .card-icon-wrapper {
            width: 60px;
            height: 60px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 1rem;
            transition: all 0.3s;
          }
          
          .questions-card:hover .card-icon-wrapper {
            transform: scale(1.08) rotate(3deg);
          }
          
          .card-icon-wrapper i {
            font-size: 1.75rem;
          }
          
          /* Background color classes matching the Settings design */
          .bg-emerald-100 { background-color: #d1fae5; color: #059669; }
          .bg-blue-100 { background-color: #dbeafe; color: #2563eb; }
          .bg-cyan-100 { background-color: #cffafe; color: #0891b2; }
          .bg-indigo-100 { background-color: #e0e7ff; color: #4f46e5; }
          .bg-rose-100 { background-color: #ffe4e6; color: #e11d48; }
          .bg-amber-100 { background-color: #fef3c7; color: #d97706; }
          
          .questions-card h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #2d3748;
            margin-bottom: 0.375rem;
          }
          
          .questions-card p {
            font-size: 0.8125rem;
            color: #718096;
            margin-bottom: 0.75rem;
            flex-grow: 1;
            line-height: 1.4;
          }
          
          .card-action {
            font-size: 0.8125rem;
            font-weight: 500;
            color: #4f46e5;
            opacity: 0;
            transform: translateX(-8px);
            transition: all 0.3s;
          }
          
          /* Responsive design */
          @media (max-width: 768px) {
            .questions-container {
              padding: 1rem;
            }
            
            .dashboard-stats-row {
              flex-direction: column;
              gap: 1rem;
              padding: 1.5rem 1rem;
            }
            
            .stats-item {
              width: 100%;
              padding: 0.5rem 0;
            }
            
            .stats-item:not(:last-child)::after {
              display: none;
            }
            
            .stats-item:not(:last-child) {
              border-bottom: 1px solid #e2e8f0;
            }
            
            .stats-icon {
              width: 40px;
              height: 40px;
              margin-right: 0.875rem;
            }
            
            .stats-icon i {
              font-size: 1.125rem;
            }
            
            .stats-label {
              font-size: 0.75rem;
            }
            
            .stats-value {
              font-size: 1.25rem;
            }
            
            .questions-header h1 {
              font-size: 1.75rem;
            }
            
            .questions-header p {
              font-size: 0.9375rem;
            }
            
            .questions-grid {
              grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
              gap: 1rem;
            }
            
            .questions-card {
              padding: 1.25rem;
              min-height: 160px;
            }
            
            .card-icon-wrapper {
              width: 56px;
              height: 56px;
              border-radius: 14px;
            }
            
            .card-icon-wrapper i {
              font-size: 1.5rem;
            }
          }
          
          @media (max-width: 480px) {
            .questions-grid {
              grid-template-columns: 1fr;
              max-width: 280px;
            }
            
            .questions-card {
              min-height: 140px;
              padding: 1rem;
            }
          }
          
          @media (min-width: 768px) and (max-width: 1024px) {
            .questions-grid {
              grid-template-columns: repeat(2, 1fr);
            }
            
            .dashboard-stats-row {
              padding: 1rem;
            }
            
            .stats-icon {
              width: 40px;
              height: 40px;
              margin-right: 0.75rem;
            }
            
            .stats-label {
              font-size: 0.75rem;
            }
            
            .stats-value {
              font-size: 1.25rem;
            }
          }
          
          @media (min-width: 1024px) {
            .questions-grid {
              grid-template-columns: repeat(4, 1fr);
            }
          }

          @media (min-width: 1024px) and (max-width: 1366px) {
            .dashboard-stats-row {
              padding: 1rem;
            }
            
            .stats-icon {
              width: 40px;
              height: 40px;
            }
            
            .stats-label {
              font-size: 0.75rem;
            }
            
            .stats-value {
              font-size: 1.25rem;
            }
            
            .questions-grid {
              gap: 1rem;
            }

            .questions-card {
              padding: 1.15rem;
              min-height: 150px;
            }

            .card-icon-wrapper {
              width: 52px;
              height: 52px;
              border-radius: 12px;
              margin-bottom: 0.75rem;
            }

            .card-icon-wrapper i {
              font-size: 1.4rem;
            }

            .questions-card h3 {
              font-size: 1rem;
              margin-bottom: 0.25rem;
            }

            .questions-card p {
              font-size: 0.75rem;
              margin-bottom: 0.5rem;
            }

            .card-action {
              font-size: 0.75rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Questions;